define('controllers/findhotel',['require'],function(require) {
    return function() {
        $(".btnUnlockUser").on("click", function () { return confirm("Are you sure you want to unlock the hotel portal users for this account?"); });
    };
});

